import i18n from "discourse-common/helpers/i18n";
import SectionLink from "../section-link";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import templateOnly from "@ember/component/template-only";
const SidebarCommonAllCategoriesSectionLink = setComponentTemplate(createTemplateFactory(
/*
  
  <SectionLink
    @linkName="all-categories"
    @content={{i18n "sidebar.all_categories"}}
    @route="discovery.categories"
    @prefixType="icon"
    @prefixValue="sidebar.all_categories"
  />

*/
{
  "id": "YWEH8fqk",
  "block": "[[[1,\"\\n  \"],[8,[32,0],null,[[\"@linkName\",\"@content\",\"@route\",\"@prefixType\",\"@prefixValue\"],[\"all-categories\",[28,[32,1],[\"sidebar.all_categories\"],null],\"discovery.categories\",\"icon\",\"sidebar.all_categories\"]],null],[1,\"\\n\"]],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/common/all-categories-section-link.js",
  "scope": () => [SectionLink, i18n],
  "isStrictMode": true
}), templateOnly());
export default SidebarCommonAllCategoriesSectionLink;